module.exports = __webpack_public_path__ + "img/i-swipe-1.919b30b5.png";